import type { ColorScheme } from '@unifyapps/defs/types/interface';
import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { COLOR_SCHEME_SEARCH_PARAMS_KEY } from '@unifyapps/network/auth/const';
import { useRouter } from '../../../../useRouter';

export function useUpdateColorSchemeForPublicInterface() {
  const router = useRouter();
  const pathname = router.pathname;
  const searchParams = router.searchParams;

  const updateColorSchemeForPublicInterface = useEventCallback((colorScheme: ColorScheme) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(COLOR_SCHEME_SEARCH_PARAMS_KEY, colorScheme);
    const newUrl = `${pathname}?${newSearchParams.toString()}`;
    router.replace(newUrl, true);
    return Promise.resolve();
  });

  return { updateColorSchemeForPublicInterface };
}
